// extracted by mini-css-extract-plugin
export default {"progressBar":"Summary_progressBar__XbDjW","badgeSummary":"Summary_badgeSummary__HOYUP"};